package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

// The Apple mark: body + leaf as one filled path. Apple's Sign in with Apple guidelines require the
// official mark on the button (a generic glyph is a review risk), and it must be a single flat
// colour — so the caller passes the button's content colour rather than this picking a theme token.
private const val APPLE_MARK =
    "M17.05 12.54c-.03-2.73 2.23-4.04 2.33-4.11-1.27-1.86-3.25-2.11-3.95-2.14-1.68-.17-3.28 1-4.13 1-.85 0-2.16-.98-3.56-.95-1.83.03-3.52 1.06-4.46 2.7-1.9 3.3-.49 8.19 1.36 10.87.9 1.31 1.98 2.78 3.39 2.73 1.36-.06 1.87-.88 3.52-.88 1.64 0 2.11.88 3.55.85 1.47-.03 2.4-1.34 3.3-2.65 1.04-1.52 1.47-2.99 1.5-3.07-.03-.01-2.88-1.11-2.91-4.39z" +
        "M14.68 4.5c.75-.91 1.25-2.17 1.11-3.43-1.08.04-2.39.72-3.16 1.63-.69.8-1.3 2.09-1.14 3.32 1.2.09 2.44-.61 3.19-1.52z"

/**
 * Apple's mark for the Sign in with Apple button, tinted to [tint] (the button's content colour) so
 * it reads correctly on light and dark surfaces. Decorative — the button carries the label.
 */
@Composable
fun AppleLogo(
    modifier: Modifier = Modifier,
    size: Dp = AppTheme.sizes.iconButton,
    tint: Color = AppTheme.colors.onSurface,
) {
    Image(
        painter = appleLogoPainter(tint),
        contentDescription = null,
        modifier = modifier.size(size),
        contentScale = ContentScale.Fit,
    )
}

@Composable
private fun appleLogoPainter(tint: Color): Painter {
    val vector = remember(tint) {
        ImageVector.Builder(
            name = "AppleMark",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f,
        ).apply {
            addPath(
                pathData = PathParser().parsePathString(APPLE_MARK).toNodes(),
                fill = SolidColor(tint),
            )
        }.build()
    }
    return rememberVectorPainter(vector)
}
